module.exports = {
    backendServer: {
      //url: 'http://192.168.1.94:8080/'
      url: 'https://node.adaste.com/'
    },
    apiServer: {
     //  url: 'https://127.0.0.1:8000'
      url: 'https://api.adaste.com'
    }
  }